import type { PropsWithChildren } from 'react';
import { TamaguiProvider } from 'tamagui';

import kindredTamaguiConfig from './config';
import { kindredDefaultTheme } from './themes';

export function KindredTamaguiProvider({ children }: PropsWithChildren) {
  return (
    <TamaguiProvider config={kindredTamaguiConfig} defaultTheme={kindredDefaultTheme}>
      {children}
    </TamaguiProvider>
  );
}
